// Law updates for the Electra HR edition of "Employing People: What HR Won't Tell You".
// The book prints electra-hr.com/book/updates, so keep that URL stable for the life of the edition.
// Add new rows at the top (newest first). When a change lands, flip its status to "In force"
// and update `verified`.

export const BOOK = {
  title: "Employing People: What HR Won't Tell You",
  subtitle: "The Plain-English Guide for Small UK Employers",
  author: "Vanessa Challess",
  edition: "First edition, Electra HR imprint",
  lawStatedAt: "25 October 2026",
};

export const LAST_CHECKED = { iso: "2026-10-25", label: "25 October 2026" };

export const STATUS_LABELS = [
  { label: "In force", text: "The law already applies." },
  { label: "Fixed commencement", text: "Regulations fix the start date, but it is not law yet. Read it as \"this applies from [date]\"." },
  { label: "Government intention", text: "The government has said when it intends the change to start, but nothing fixing the date has been made. These dates can move." },
  { label: "Consultation only", text: "Proposals out for consultation, with no commitment to a date." },
];

export const UPDATES = [
  {
    date: "1 January 2027",
    iso: "2027-01-01",
    change:
      "The unfair dismissal qualifying period falls from two years to six months, and the cap on the compensatory award is removed (SI 2026/559).",
    status: "Fixed commencement",
    verified: "25 October 2026",
    chapters: "4, 9, 12, 13 and the tracker",
  },
  {
    date: "9 November 2026",
    iso: "2026-11-09",
    change:
      "Breach of contract claims in Scotland move to a six-month time limit, matching England and Wales. The Scottish order was still in draft on 25 October 2026.",
    status: "Government intention",
    verified: "25 October 2026",
    chapters: "4, 15 and the tracker",
  },
  {
    date: "30 October 2026",
    iso: "2026-10-30",
    change:
      "Employers must take all reasonable steps to prevent sexual harassment, and become liable for harassment of their staff by third parties such as customers and clients (Employment Rights Act 2025, ss.20 to 22; SI 2026/1065).",
    status: "Fixed commencement",
    verified: "25 October 2026",
    chapters: "10 and the tracker",
  },
  {
    date: "No date set",
    iso: null,
    change:
      "Acas Code of Practice on disciplinary and grievance procedures: consultation on a replacement Code closed on 23 September 2026. The 2015 Code still applies.",
    status: "Consultation only",
    verified: "25 October 2026",
    chapters: "11, 12",
  },
];
